import { IServiceFactory } from '../../common/types/service-factory';
import { IReferenceValuesApiService, ReferenceValuesApiService } from '../services/reference-values-api-service';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class ReferenceValuesApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IReferenceValuesApiService> {
	public Create(): IReferenceValuesApiService {
		return new ReferenceValuesApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
